
import { Component, Prop, Vue } from 'vue-property-decorator';

// Interfaces
import IDictionary from '@/ship/Models/IDictionary';

@Component
export default class PMChartStatus extends Vue {
    @Prop({ type: Number, default: NaN }) chartStatus!: number;
    @Prop({ type: Map, default: () => ({}) }) statuses!: IDictionary;

    get isShown() {
        return !!this.chartStatus;
    }

    get statusInfo() {
        let status = {
            label: '',
            color: '#FFF',
            background: '#FFF',
            border: '#FFF',
        };

        if (this.isShown) {
            status = this.statuses.get(this.chartStatus);
        }

        return status;
    }
}
